<template>
    <vx-card title="Добавить модель" id="loader">
        <h6>Основные настройки</h6>
        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.modelName"
                        :danger="!!errors.modelName"
                        :danger-text="errors.modelName"
                        autocomplete="off"
                        label="Наименование модели"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Датасет </label>
                    <v-select
                        :options="dicts.datasets"
                        placeholder="Выберите датасет"
                        label="datasetName"
                        class="w-full"
                        v-model="item.datasetId"
                        v-bind:class="{ 'v-select-error': !!errors.datasetId }"
                        @input="onChangeDataset()"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.datasetId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.datasetId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Тип модели </label>
                    <v-select
                        :options="dicts.modelTypes"
                        placeholder="Выберите тип модели"
                        label="modelClass"
                        class="w-full"
                        v-model="item.modelTypeId"
                        v-bind:class="{ 'v-select-error': !!errors.modelTypeId }"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.modelTypeId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.modelTypeId }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Тип энкодинга </label>
                    <v-select
                        :options="dicts.featureEncodingTypes"
                        placeholder="Выберите тип энкодинга"
                        label="name"
                        class="w-full"
                        v-model="item.featureEncodingId"
                        v-bind:class="{ 'v-select-error': !!errors.featureEncodingId }"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.featureEncodingId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.featureEncodingId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <h6>Параметры обучения</h6>
                <div class="vx-col w-full" v-for="(param, index) in item.trainParams">
                    <div v-if="param.type == 1" class="mt-1">
                        <vs-input
                            v-model="param.value"
                            :label="param.name + ' (по умолчанию ' + param.defaultValue + ')'"
                            :danger="!!getTrainParamError(index)"
                            :danger-text="getTrainParamError(index)"
                            autocomplete="off"
                            class="mt-1 w-full required"
                    />
                    </div>
                    <div v-if="param.type == 2" class="mt-1">
                        <label class="vs-input--label required"> {{ param.name }} (по умолчанию {{ param.defaultValue }} </label>
                        <v-select
                            :options="param.options"
                            placeholder="Выберите значение"
                            label="name"
                            class="w-full"
                            v-model="param.value"
                            v-bind:class="{ 'v-select-error': !!getTrainParamError(index) }"
                            :reduce="(a) => a.id"
                        ></v-select>
                        <div v-if="getTrainParamError(index)"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                            style="height: 19px"
                        >
                            <span class="span-text-validation">
                                {{ getTrainParamError(index) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col w-1/3">
                <h6>Параметры энкодинга</h6>
                <div class="vx-col w-full" v-for="(param, index) in item.encodingParams">
                    <div v-if="param.type == 1" class="mt-1">
                        <vs-input
                            v-model="param.value"
                            :label="param.name + ' (по умолчанию ' + param.defaultValue + ')'"
                            :danger="!!getEncodingParamError(index)"
                            :danger-text="getEncodingParamError(index)"
                            autocomplete="off"
                            class="mt-1 w-full required"
                        />
                    </div>
                    <div v-if="param.type == 2" class="mt-1">
                        <label class="vs-input--label required"> {{ param.name }} (по умолчанию {{ param.defaultValue }} </label>
                        <v-select
                            :options="param.options"
                            placeholder="Выберите значение"
                            label="name"
                            class="w-full"
                            v-model="param.value"
                            v-bind:class="{ 'v-select-error': !!getEncodingParamError(index) }"
                            :reduce="(a) => a.id"
                        ></v-select>
                        <div v-if="getEncodingParamError(index)"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                            style="height: 19px"
                        >
                            <span class="span-text-validation">
                                {{ getEncodingParamError(index) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h6 class="mt-5">Список фич</h6>
        <div class="mt-5" v-if="!item.datasetId && item.features.length == 0">
            <strong>Выберите датасет</strong>
        </div>

        <div v-if="item.features && item.features.length > 0" class="vx-col w-full pl-6">
            <div class="mt-1">
                <template>
                    <div class="vx-row mt-3">
                        <div class="vx-col w-1/3">
                            <h6>Фича</h6>
                        </div>

                        <div class="vx-col w-1/3">
                            <h6>Поля</h6>
                        </div> 

                        <div class="vx-col w-1/3">
                            
                        </div>
                    </div>

                    <div v-for="(feature, index) in item.features" :key="index" class="row">
                        <template>
                            <div class="vx-row mt-3">
                                <div class="vx-col w-1/3">
                                    <v-select
                                        :options="dicts.features"
                                        label="name"
                                        placeholder="Выберите фичу"
                                        class="w-full"
                                        v-model="feature.featureId"
                                        v-bind:class="{ 'v-select-error': !!getFeatureError(index, 'FeatureId') }"
                                        @input="onChangeFeature(feature)"
                                        :reduce="a => a.id"
                                        :clearable="false"
                                    ></v-select>
                                    <div v-if="getFeatureError(index, 'FeatureId')"
                                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                                        style="height: 19px"
                                    >
                                        <span class="span-text-validation">
                                            {{ getFeatureError(index, 'FeatureId') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="vx-col w-1/3">
                                    <div class="mt-2"><small>{{ getFieldsData(feature.fields) }}</small></div>
                                </div> 

                                <div class="vx-col w-1/3">
                                    <div class="float-right">
                                    <vs-button round @click="remove(index)" icon="delete" color="danger" />
                                        <vs-button
                                            round
                                            v-if="index + 1 === item.features.length"
                                            @click="add"
                                            icon="control_point"
                                            color="success"
                                            class="add-row"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled"> Сохранить </vs-button>
                <vs-button class="mt-5 mr-2" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
                <!-- <vs-button class="mt-5" color="warning" @click="validate()" type="filled"> Проверить </vs-button> -->
            </div>
        </div>
    </vx-card>
</template>


<script>
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

export default {
    name: 'cpa-push-model-create',
    data() {
        return {
            item: {
                modelName: '',
                datasetId: '',
                modelTypeId: '',
                featureEncodingId: '',
                encodingParams: [],
                trainParams: [],
                features: [],
                allFeatues: []
            },
            form: {},
            dicts: {
                datasets: [],
                modelTypes: [],
                featureEncodingTypes: [],
                features: []
            },
            errors: {
                modelName: '',
                datasetId: '',
                modelTypeId: '',
                featureEncodingId: '',
                encodingParams: '',
                trainParams: ''
            }
        };
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([
                    this.axios.get('cpa-push-model/new'),
                    this.axios.get('cpa-push-model/dicts')
                ])
                .then(
                    axios.spread((item, dicts) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.item = item.data;
                        this.dicts.datasets = dicts.data.datasets;
                        this.dicts.modelTypes = dicts.data.modelTypes;
                        this.dicts.featureEncodingTypes = dicts.data.featureEncodingTypes;
                        this.dicts.features = dicts.data.features;
                        this.dicts.allFeatures = dicts.data.features;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки модели.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },

        getDatasetFeatures(datasetId) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([
                    this.axios.get('cpa-push-dataset/' + datasetId + '/features')
                ])
                .then(
                    axios.spread((datasetFeatures) => {
                        debugger
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.item.features = datasetFeatures.data;
                        const dictFeatures = [];
                        datasetFeatures.data
                            .forEach(f => {
                                const feature = this.dicts.allFeatures
                                    .find(df => df.id == f.featureId);
                                if (feature) {
                                    dictFeatures.push(feature);
                                }
                            });
                        this.dicts.features = dictFeatures;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки фич.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },

        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.item, { 
                id: this.id
            });

            this.$axios({
                method: 'POST',
                url: 'cpa-push-model',
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно изменена",
                        text: "Модель успешно добавлена",
                        color: "success",
                    });
                    this.$router.push('/cpa-push-models/model');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors) {
                        if (err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger'
                            });
                        } else {
                            Object.entries(err.data.errors).forEach(entry => {
                                const [key, value] = entry;
                                console.log(key, value);
                                this.errors[key] = value && value.length > 0 ? value[0] : '';
                            });
                        }
                    }

                    this.$forceUpdate();

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при добавлении модели!",
                        color: "danger",
                    });
                }
            })
        },

        // Model features.
        remove(featureId) {
            if (!this.itemRemoval) {
                this.item.features.splice(featureId, 1);
            } else {
                this.item.features = [];
                this.add();
            }
        },
        add() {
            // if (!this.validate()) {
            //     return;
            // }

            this.item.features.push({
                featureId: null
            });
        },

        getFeatureError(index, field) {
            if (this.errors) {
                var key = `features[${index}].${field}`;
                var error = this.errors[key];

                return error;
            }
        },

        getEncodingParamError(index) {
            if (this.errors) {
                var key = `encodingParams[${index}].Value`;
                var error = this.errors[key];

                return error;
            }
        },

        getTrainParamError(index) {
            if (this.errors) {
                var key = `trainParams[${index}].Value`;
                var error = this.errors[key];

                return error;
            }
        },

        getFieldsData(fields) {
            if (!fields) {
                return;
            }

            const fieldsArr = fields.map(function (f) {
                return f.name + ' (' + f.statement + ')'
            });

            return fieldsArr.join(); 
        },

        onChangeFeature(feature) {
            debugger
            let dictFeature = this.dicts.features.find(m => m.id == feature.featureId);
            if (!dictFeature) {
                return;
            }

            feature.fields = dictFeature.fields;
        },

        onChangeDataset() {
            if (this.item.datasetId) {
                this.getDatasetFeatures(this.item.datasetId);
            }
        },

        cancelEdit() {
            this.$router.push('/cpa-push-models/model');
        }
    },
    mounted() {
        this.add();
        this.loadData();
    },
    watch: {
        features() {
            this.itemRemoval = this.item.features.length <= 1;
        }
    },
};
</script>

<style scoped>
.hr-line-row{
  display: flex;
  align-items: center
}
.hr-line{
  /* border-bottom: 2px solid red; */
  flex: 1;
}
.hr-span {
    margin-right: 15px;
    font-weight: bold;
}
</style>